import AuthComponent from "@/components/api/AuthComponent";
import {sessionName, setSessionWithCrypto, clearSession} from "@/utils/Session"
import {handleApiError} from "@/utils/VuexUtil";

const MODULE_NAME = 'auth'

const state = {
    isLoading: false,
    errorsLogin: null,
    isLoggedIn: false,
    tokenType: null,
    credentials: null
}

export const AuthActionTypeEnum = {
    login: '['+MODULE_NAME+'] login',
    tokens: '['+MODULE_NAME+'] tokens',
    logout: '['+MODULE_NAME+'] logout'
};

const MutationTypeEnum = {
    loginStart: '['+MODULE_NAME+'] loginStart',
    loginSuccess: '['+MODULE_NAME+'] loginSuccess',
    loginFailure: '['+MODULE_NAME+'] loginFailure',
    tokensStart: '['+MODULE_NAME+'] tokensStart',
    tokensSuccess: '['+MODULE_NAME+'] tokensSuccess',
    tokensFailure: '['+MODULE_NAME+'] tokensFailure',
    logout: '['+MODULE_NAME+'] logout',
};

const getters = {
    getSubmitting: state => state.isLoading,
    getValidationErrorsLogin: state => state.errorsLogin,
    isLoggedIn: state => state.isLoggedIn,
    getCredentials: state => state.credentials,
    isAuthenticated: state => !!state.credentials || !!sessionStorage.getItem('credential'),
}

const mutations = {
    // Login
    [MutationTypeEnum.loginStart](state) {
        state.isLoading = true
        state.errorsLogin = null
    },
    async [MutationTypeEnum.loginSuccess](state, response) {
        if (response.status === 200) {
            await setSessionWithCrypto(sessionName.CREDENTIAL, response.data.result)
            state.credentials = response.data.result
            state.isLoading = false
            state.isLoggedIn = true
        }
    },
    [MutationTypeEnum.loginFailure](state, response) {
        if (response) state.errorsLogin = response.errors
        state.isLoading = false
        state.isLoggedIn = false
    },

    // Token
    [MutationTypeEnum.tokensStart](state) {
        state.errors = null
    },
    async [MutationTypeEnum.tokensSuccess](state, response) {
        if (response.status === 200) {
            await setSessionWithCrypto(sessionName.CREDENTIAL, response.data.result)
            state.credentials = response.data.result
            state.isLoading = false
            state.isLoggedIn = true
        }
    },
    [MutationTypeEnum.tokensFailure](state, response) {
        if (response) state.errorsLogin = response.errors
        state.isLoggedIn = false
    },

    // Logout
    [MutationTypeEnum.logout](state) {
        state.isLoggedIn = false
        state.tokenType = null
        state.credentials = null
        clearSession()
    }
}

const actions = {
    async [AuthActionTypeEnum.login](context, credentials) {
        context.commit(MutationTypeEnum.loginStart);
        try {
            const response = await AuthComponent.login(credentials);
            context.commit(MutationTypeEnum.loginSuccess, response);
            return response;
        } catch (error) {
            const formattedError = handleApiError(error);
            context.commit(MutationTypeEnum.loginFailure, formattedError);
            return formattedError;
        }
    },

    async [AuthActionTypeEnum.tokens](context, credentials) {
        context.commit(MutationTypeEnum.tokensStart)
        try {
            const response = await AuthComponent.tokens(credentials);
            context.commit(MutationTypeEnum.tokensSuccess, response);
            return response;
        } catch (error) {
            const formattedError = handleApiError(error);
            // Если ошибка 401/403 - не показываем ошибку, роутер сам перенаправит
            if (error.response?.status === 401 || error.response?.status === 403) {
                return formattedError;
            }
            context.commit(MutationTypeEnum.tokensFailure, formattedError);
            return formattedError;
        }
    },

    async [AuthActionTypeEnum.logout](context) {
        try {
            context.commit(MutationTypeEnum.logout)
        } catch (error) {
            console.error('Logout error:', error)
            context.commit(MutationTypeEnum.logout)
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
};